/* 🤖 this file was generated by svg-to-ts */
export const siriusCopyDuotone: {
  name: 'copy_duotone';
  data: string;
} = {
  name: 'copy_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M15.75 8.25v7.5h4.5v-12h-12v4.5h7.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 3a.75.75 0 0 0-.75.75V7.5H3.75a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V16.5h3.75a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75h-12Zm8.25 12h3V4.5H9v3h6.75a.75.75 0 0 1 .75.75V15Zm-12-6v10.5H15V9H4.5Z" fill="currentColor"/></svg>`
};
